import configureAxios from 'configure/axios';

const axios = configureAxios();

export const fetchAll = (subId) => axios.get('plans/', { params: { subscription_id: subId } });
export const find = (id) => axios.get(`plans/${id}/`);
export const upcomingCycles = (subscription) => axios.get('cycles/upcoming/', { params: { subscription } });
